<div class="channels">
    @if(contentType) {
        <div style="margin-right: 5px; align-content:center">Your Channels {{contentType}}</div>
    }
    <div class="chipHolder"> 
        @for (c of channels; track $index) {
            <!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->            
            <div class="chip" [ngClass]="(selectedChannel && selectedChannel.id !== c.id) ? 'notselected' : null"  
            [attr.data-id]="'channel-picker-' + c?.pillColor"
            (click)="selectChannel(c)" [matTooltip]="c.from"
                [style.backgroundColor]="c.paint.background"
                [style.color]="c.paint.text"><mat-icon class="chipIcon">{{c.icon}}</mat-icon>{{c.name}}</div>
        }
    </div>
</div>
